var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"alert-wrapper"},_vm._l((this.$root.$data.alerts),function(alert){return _c('div',{staticClass:"alert",class:'alert-'+alert.type},[_vm._v("\n        "+_vm._s(alert.message)+"\n    ")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }